import { Star, BadgeCheck } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

function initials(name) {
  return name.split(" ").slice(0, 2).map((n) => n[0]).join("").toUpperCase();
}
const COLORS = ["bg-[#0F294A]", "bg-emerald-600", "bg-amber-600", "bg-indigo-700", "bg-rose-600", "bg-teal-700"];

export default function Testimonials() {
  return (
    <section id="depoimentos" className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-semibold tracking-wider uppercase text-emerald-600 mb-3">Depoimentos</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">
            Quem já resolveu, recomenda
          </h2>
          <div className="mt-4 flex items-center gap-3">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />)}</div>
            <span className="text-slate-600 font-medium">4,9 de 5 · +45 mil atendimentos realizados</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {TESTIMONIALS.map((t, i) => (
            <figure key={t.name} data-testid={`testimonial-${i}`} className="bg-white rounded-2xl border border-slate-200 p-6 flex flex-col hover:shadow-lg transition-shadow">
              <div className="flex mb-4">{[...Array(t.rating)].map((_, s) => <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" />)}</div>
              <blockquote className="text-slate-700 leading-relaxed flex-1">"{t.text}"</blockquote>
              <figcaption className="mt-5 pt-5 border-t border-slate-100 flex items-center gap-3">
                <span className={`grid place-items-center h-11 w-11 rounded-full text-white font-bold text-sm ${COLORS[i % COLORS.length]}`}>{initials(t.name)}</span>
                <div>
                  <p className="font-bold text-slate-900 text-sm flex items-center gap-1">{t.name} <BadgeCheck className="h-4 w-4 text-emerald-500" /></p>
                  <p className="text-xs text-slate-500">{t.role} · {t.city}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
